import * as React from "react";
import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FaqHero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const heroImages = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/hero-sorter.jpg",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/hero-sorter.jpg-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/hero-sorter.jpg-wvc-sizes",
    alt: "High-precision sorting equipment - View 1"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/hero-warehouse.jpg",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/hero-warehouse.jpg-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/hero-warehouse.jpg-wvc-sizes",
    alt: "High-precision sorting equipment - View 2"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/hero-logistics.jpg",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/hero-logistics.jpg-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663779/img/hero-logistics.jpg-wvc-sizes",
    alt: "High-precision sorting equipment - View 3"
  }];
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [currentSlide, heroImages.length]);
  const handleSlideChange = (index: number) => {
    setCurrentSlide(index);
  };
  return <section data-section-id="252310" id="future-ready-industrial-excellence" className="relative w-full min-h-screen bg-[#0b0d0f] text-foreground py-24 md:py-32 lg:py-40 overflow-hidden flex items-center">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(115,166,102,0.1)_0%,transparent_50%)] pointer-events-none" />
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCI+CjxwYXRoIGQ9Ik0zMCAwTDU1Ljk4IDExLjI1VjMzLjc1TDMwIDQ1TDUuMDIgMzMuNzVWMTEuMjVMMzAgMFoiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjA1IiBzdHJva2Utd2lkdGg9IjAuNSIvPgo8L3N2Zz4=')] opacity-30 pointer-events-none" />

      {}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-full h-full pointer-events-none z-0">
        {heroImages.map((image, index) => <img key={index} data-index={index} src={image.src} alt={image.alt} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} className={`absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000 ease-in-out ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`} loading={index === 0 ? "eager" : "lazy"} />)}
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl">
          <div className="flex items-center gap-2 mb-6">
            <span className="flex h-2 w-2 rounded-lg bg-primary animate-pulse" />
            <span className="text-xs md:text-sm font-default font-semibold tracking-wider uppercase text-primary border border-primary/30 px-4 py-1 rounded-lg bg-primary/5 backdrop-blur-sm">
              Smart Sorting Equipment
            </span>
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-[64px] font-default font-bold mb-8 leading-[1.1] tracking-tight text-white animate-in fade-in slide-in-from-left-4 duration-1000">
            High-precision, high-speed <br className="hidden md:block" /> sorting equipment
          </h1>
          
          <p className="text-lg md:text-xl text-foreground/80 mb-10 max-w-2xl leading-relaxed font-default">
            Focused on the R&D and production of intelligent sorting systems for logistics, e-commerce and express delivery worldwide.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/ProductsPage">
              <Button size="lg" variant="default" className="h-14 px-8 text-base font-semibold rounded-md bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-lg transition-all duration-300 group">
                View Products
                <ArrowRight className="ml-2 size-5 transition-transform duration-300 group-hover:translate-x-1" />
              </Button>
            </Link>
            <Link to="/ContactPage">
              <Button size="lg" variant="secondary" className="h-14 px-8 text-base font-semibold rounded-md bg-secondary text-secondary-foreground hover:opacity-90 transition-all duration-300">
                Get a Quote
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex gap-3 z-20">
        {heroImages.map((_, index) => <Button key={index} data-index={index} variant="ghost" size="sm" onClick={() => handleSlideChange(index)} className={`p-0 h-1.5 w-8 rounded-full transition-all duration-300 hover:bg-primary/50 ${index === currentSlide ? 'bg-primary' : 'bg-white/20'}`} aria-label={`Go to slide ${index + 1}`} />)}
      </div>
    </section>;
}